/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreHistoryManagementEditOrderDetailRequest } from './StoreHistoryManagementEditOrderDetailRequest';
import type { StoreHistoryManagementEditOrderUnitRequest } from './StoreHistoryManagementEditOrderUnitRequest';

export type StoreHistoryManagementEditOrderRequest = {
    id: number;
    invoiceMemberAddressid?: number;
    invoiceName: string;
    invoiceZip: string;
    invoiceAddress1: string;
    invoiceAddress2: string;
    invoiceAddress3?: string | null;
    invoiceTel: string;
    destinationMemberAddressid?: number;
    destinationName: string;
    destinationZip: string;
    destinationAddress1: string;
    destinationAddress2: string;
    destinationAddress3?: string | null;
    destinationTel: string;
    orderDetails?: Array<StoreHistoryManagementEditOrderDetailRequest>;
    usePoint?: number;
    orderUnits?: Array<StoreHistoryManagementEditOrderUnitRequest>;
    paymentType: StoreHistoryManagementEditOrderRequest.paymentType;
    paymentLimitDate?: string | null;
    deliveryPreferredDate?: string | null;
    deliveryPreferredTime?: number | null;
    note?: string | null;
    status?: StoreHistoryManagementEditOrderRequest.status;
    noteStaff?: string | null;
};

export namespace StoreHistoryManagementEditOrderRequest {

    export enum paymentType {
        BANK = 'Bank',
        C_O_D = 'C.O.D',
        DIRECT = 'Direct',
    }

    export enum status {
        INITIAL = 'initial',
        RESERVED = 'reserved',
        CONFIRMED = 'confirmed',
        PACKING = 'packing',
        STOCK = 'stock',
        SENTED = 'sented',
        CANCEL = 'cancel',
    }


}

